import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const rawClockingLocaleModule: LocaleModule = {
  name: "rawClocking",
  messages: { en: en, it: it },
};
